import axios from 'axios';

const API_URL = 'http://localhost:4500';
const PROD_API_URL = 'https://central-service.fly.dev/'

const isProd = process.env.NODE_ENV === 'production';

const axiosInstance = axios.create({
    baseURL: isProd ? PROD_API_URL : API_URL,
    timeout: 30000,
    // headers: { 'Referer': API_URL },
    responseType: 'json'
});

axiosInstance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response && error.response.status === 401) {
        // Handle unauthorized error here
        // console.log('Unauthorized!');
        // window.location.replace('/login')
    }
    return Promise.reject(error);
});

export default axiosInstance;